"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SuggestedTopicsListContainer = void 0;

var _preact = require("preact");

var _connectors = require("@insided/shared/services/algolia/connectors");

var _phrase = _interopRequireDefault(require("../../libs/translationsUtils/phrase"));

var _SuggestedTopicsList = _interopRequireDefault(require("./SuggestedTopicsList"));

var SuggestedTopicsListContainer = function SuggestedTopicsListContainer(_ref) {
  var hits = _ref.hits;
  if (!hits.length) return null;
  return (0, _preact.h)("div", null, (0, _preact.h)("div", {
    className: "topic-create_suggestions-title"
  }, (0, _preact.h)(_phrase.default, {
    p: "related.topics.title"
  })), (0, _preact.h)(_SuggestedTopicsList.default, {
    hits: hits
  }));
};

exports.SuggestedTopicsListContainer = SuggestedTopicsListContainer;
var SuggestedTopicsListWrapper = (0, _connectors.connectHits)(SuggestedTopicsListContainer);
var _default = SuggestedTopicsListWrapper;
exports.default = _default;